import CryptoJS from 'crypto-js'

/**
 * Desencripta un string encriptado con el algoritmo AES-256-CBC.
 * @param {string} str String encriptado.
 */
export function decryptAES(str) {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY

    // Convertir clave de encriptación a WordArray
    const key = CryptoJS.enc.Utf8.parse(encryptionKey)

    // Obtener IV y datos codificados en base64
    const [ivBase64, encryptedDataBase64] = atob(str).split('::', 2)

    // Convertir IV de base64 a WordArray
    const iv = CryptoJS.enc.Base64.parse(ivBase64)

    // Desencriptar datos
    const decrypted = CryptoJS.AES.decrypt(encryptedDataBase64, key, { iv })

    return decrypted.toString(CryptoJS.enc.Utf8)

}
